(function () {
  if (window.__millysCartUpsellBound) return;
  window.__millysCartUpsellBound = true;

  function sectionsFor(cartDrawer) {
    return (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-upsell__add');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = sectionsFor(cartDrawer);
    var addId = btn.dataset.variantId;
    var removeId = btn.dataset.removeId;

    var request;
    if (removeId) {
      // Upgrade: swap the smaller pack for the larger one in one atomic update.
      var updates = {};
      updates[addId] = 1;
      updates[removeId] = 0;
      var updateUrl = (window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : '/cart/update.js';
      request = fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
      });
    } else {
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      request = fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: addId, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      });
    }

    request
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed.status) { console.warn('[cart-upsell] failed', parsed); return; }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsed);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) { console.error('[cart-upsell]', err); })
      .finally(function () { btn.setAttribute('aria-busy', 'false'); });
  });
})();